<template>
  <div id="bsc">
    <div class="bsc-container">
      <div class="bsc-container-top">
        <div class="bsc-logo">
          <img src="./u287.png" alt="" />
        </div>
        <div class="title-h1">
          <h1>升职加薪,快乐成长!</h1>
        </div>
      </div>
      <div class="bsc-body">
        <div class="menu-aside">
          <LeftMenu></LeftMenu>
        </div>
        <div class="bsc-main">
          <router-view></router-view>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LeftMenu from './LeftMenu.vue'
import { onMounted, reactive, ref, provide, getCurrentInstance } from '@vue/composition-api'
import Watermark from 'watermark-plus'
import watermarkDom from 'watermark-dom'
export default {
  name: 'Bsc',
  props: [],
  setup () {
    const vm = getCurrentInstance()
    const a = vm.proxy.$route.query.userId
    console.log(vm.proxy.$route.query.userId)
    provide('userId', a)
    onMounted(() => {
      // const watermark = new Watermark({
      //   // 传参
      //   content: 'Hello World!'
      // })
      // console.log(22)
      // // 创建水印
      // watermark.create()
      // watermarkDom.load({
      //   watermark_txt: '符芳计 15342684653', // 水印的内容
      //   watermark_id: 'wm_div_id', // 水印总体的id
      //   watermark_prefix: 'mask_div_id', // 小水印的id前缀
      //   watermark_x: 20, // 水印起始位置x轴坐标
      //   watermark_y: 20, // 水印起始位置Y轴坐标
      //   watermark_rows: 0, // 水印行数
      //   watermark_cols: 0, // 水印列数
      //   watermark_x_space: 100, // 水印x轴间隔
      //   watermark_y_space: 50, // 水印y轴间隔
      //   watermark_font: '微软雅黑', // 水印字体
      //   watermark_color: 'black', // 水印字体颜色
      //   watermark_fontsize: '18px', // 水印字体大小
      //   watermark_alpha: 0.15, // 水印透明度，要求设置在大于等于0.005
      //   watermark_width: 200, // 水印宽度
      //   watermark_height: 100, // 水印长度
      //   watermark_angle: 25, // 水印倾斜度数
      //   watermark_parent_width: 0, // 水印的总体宽度（默认值：body的scrollWidth和clientWidth的较大值）
      //   watermark_parent_height: 0, // 水印的总体高度（默认值：body的scrollHeight和clientHeight的较大值）
      //   watermark_parent_node: 'bsc' // 水印插件挂载的父元素element,不输入则默认挂在body上
      // })
      createWaterMark()
    })
    window.addEventListener('resize', function (e) {
      createWaterMark()
    })
    function createWaterMark () {
      watermarkDom.load({
        watermark_txt: '符芳计 4653', // 水印的内容
        watermark_id: 'wm_div_id', // 水印总体的id
        watermark_prefix: 'mask_div_id', // 小水印的id前缀
        watermark_x: 20, // 水印起始位置x轴坐标
        watermark_y: 20, // 水印起始位置Y轴坐标
        watermark_rows: 0, // 水印行数
        watermark_cols: 0, // 水印列数
        watermark_x_space: 100, // 水印x轴间隔
        watermark_y_space: 50, // 水印y轴间隔
        watermark_font: '微软雅黑', // 水印字体
        watermark_color: 'black', // 水印字体颜色
        watermark_fontsize: '18px', // 水印字体大小
        watermark_alpha: 0.15, // 水印透明度，要求设置在大于等于0.005
        watermark_width: 200, // 水印宽度
        watermark_height: 100, // 水印长度
        watermark_angle: 25, // 水印倾斜度数
        watermark_parent_width: 0, // 水印的总体宽度（默认值：body的scrollWidth和clientWidth的较大值）
        watermark_parent_height: 0, // 水印的总体高度（默认值：body的scrollHeight和clientHeight的较大值）
        watermark_parent_node: 'bsc' // 水印插件挂载的父元素element,不输入则默认挂在body上
      })
    }
    return {

    }
  },
  components: {
    LeftMenu
  }
}
</script>

<style scoped lang="stylus">

#bsc
  // padding 0px 20px 20px 20px
  background-color: #fff !important
  box-sizing: border-box;
  width 100vw
  height 100vh
  overflow hidden
  >>> *
        box-sizing: border-box;
.bsc-container
  display flex
  flex-direction: column
  height 100%
  .bsc-body
    flex 1 1
    display flex
    overflow hidden
  .menu-aside
    border: solid 1px #e6e6e6;
    >>> .el-menu
          border-right: none
  .bsc-main
    overflow: auto
    flex 1 1
    padding 20px 20px 40px 20px

.bsc-logo
  width 200px
  img
    width 100%

.bsc-container-top
  display flex
  align-items: center
  .title-h1
    flex 1 1
    text-align center
    font-size 30px
    font-weight: bolder

</style>
